import { times } from 'lodash';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Star from './star';

interface RateProps {
  value?: number;
  onChange?: (value: number) => void;
  readonly?: boolean;
}

const Rate: React.FC<RateProps> = ({
  value = 0,
  onChange,
  readonly = true,
}) => {
  const [hoverValue, setHoverValue] = useState(0);

  useEffect(() => {
    setHoverValue(value);
  }, [value]);

  const handleClick = (index: number) => {
    if (!readonly && onChange) {
      const newValue = index + 1;
      onChange(newValue);
    }
  };

  const handleHover = (index: number) => {
    if (!readonly) {
      const newValue = index + 1;
      setHoverValue(newValue);
    }
  };

  const handleLeave = () => {
    setHoverValue(value);
  };

  return (
    <Container onMouseLeave={() => handleLeave()}>
      {times(5, (i) => {
        let val = 0;
        if (hoverValue >= i && hoverValue < i + 1) {
          val = +(hoverValue % 1).toFixed(2);
        } else if (hoverValue >= i) {
          val = 1;
        }

        return (
          <Star
            key={i}
            value={val}
            readonly={readonly}
            onClick={() => handleClick(i)}
            onMouseEnter={() => handleHover(i)}
          />
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: inline-block;
`;

export default Rate;
